import PropTypes from "prop-types";


// components
import { AppContext } from "components";
import { BaseComponent } from "shared/components";
import { WashingSelect } from "components/ProductComponents";

// controllers
import { ProductController, WashingController } from "controllers";

class WashingInstructionContainer extends BaseComponent {

    constructor(props) {
        super(props);
        this.addWashing = this.addWashing.bind(this);
    }

    addWashing(barcode, washing) {
        ProductController.editProduct(barcode, { washing });
    }

    render() {
        const product = this.props.product;

        if (typeof (product.washing) !== 'string') {
            return null;
        };

        const washingIcon = WashingController.getIconByValue(product.washing);

        return (
            <div className="columns">
                {(product.washing && washingIcon) ? <img style={{
                    height: '40px', width: 'auto', display: "block",
                    marginLeft: "auto",
                    marginRight: "0"
                }}
                    src={washingIcon}
                    alt={product.washing}

                /> : <WashingSelect
                    value={product.washing}
                    label="Washing"
                    onChange={(washing) => this.addWashing(product.barcode, washing)}
                />}

            </div>
        )
    }
}

WashingInstructionContainer.contextType = AppContext;

WashingInstructionContainer.propTypes = {
    product: PropTypes.object
};

export default WashingInstructionContainer;
